'use strict';

import showBrowseLayout from 'templates/showBrowse/showBrowseLayout.tpl';
import showBrowseItem from 'templates/showBrowse/__showBrowseItem.tpl';
import BreakPoints from 'helpers/breakpoints';
import 'carousels/helpers/ellipsify';
import 'components/subnav';

/**
 * ShowBrowse component class
 */
export default class ShowBrowse {
    constructor() {
        this._routePrefix = CBS.Registry.region.prefix + '/shows_xhr/';

        this.init();
        this.__setupButtons();
        this.__setupResizeHandler();

        window.onpopstate = function (stateObj) {
            this._setCategory(stateObj.state ? stateObj.state.category : this.initialCategory);

            this.__setNextRouteXHR(this.category);

            this.updateSubnavState();
            this.doAjax(false);
        }.bind(this);

        // trigger image revalidate on render complete event
        $(this).on('showBrowseDidRender', function () {
            if (CBS.Registry.lazyImage !== undefined) {
                setTimeout(() => {
                    CBS.Registry.lazyImage.revalidate();
                }, 200);
            }
        });
    }

    /**
     * Initialize lazy load images
     */
    __initiateVars() {
        this.brazeCampaignParams = { screenName: 'shows browse' };
        this.metaTitle = $('title');
        this.metaDesc = $('meta[name="description"]');
        this.metaOgTitle = $('meta[property="og:title"]');
        this.metaOgDesc = $('meta[property="og:description"]');

        // used as suffix to ajax calls
        this.route = '';
        this.nextRoute = '';
        this.nextRouteXHR = '';

        this.start = 0;
        this.movieLoadSize = 40; // should match MoviesManager
        this.initialIsMovies = false;

        // category to fetch (and returned)
        this.category = '';

        // ajax resp
        this.resp = '';

        // subnav buttons
        this.buttons = $('.subnav__items a');

        // parent rendering container
        this.container = $('.show-browse-container');
        this.gridContainer = $('.show-browse-grid');

        this.rowItemsByBreakpoint = {
            mobilePortrait: 4,
            mobileLandscape: 6,
            tabletPortrait: 8,
            tabletLandscape: 10,
            desktop: 14,
            desktopWide: 14
        };

        this.setRoute();
        this.initialCategory = this.category;

        this._setupMovies(this.initialCategory);
    }

    // setup the route suffix used for ajax call
    setRoute() {
        let path = document.location.pathname;
        let arr = path.split('/');
        if (arr.length === 3) {
            // for categories: /shows and /movies
            if (arr[1] === 'shows') {
                this._setCategory('popular');
            } else {
                this._setCategory('movies');
            }
        } else {
            // for all other categories
            if (arr[1] === 'movies') {
                this.initialIsMovies = true;
                this._setCategory('movies');
                // if you want movies to load more on a pushstate url uncomment this
                //this.start = Number(arr[2]);
                $('#show-browse-bottom').detach();
                $('#show-browse-all-btn').css('display', 'block');
            } else {
                this._setCategory(arr[arr.length - 2]);
            }
        }
    }

    init() {
        this.__initiateVars();
        this.__listenEvents();
        this.__initSubNavTracking();
        this.__initTracking();
    }

    trackState(stateTrackingVars) {
        let trackStateTryCatch = () => {
            try {
                om.trackState(stateTrackingVars);
            } catch (e) {
                console.error(e);
            }
        }

        if (typeof om === 'undefined') {
            setTimeout(trackStateTryCatch, 2000);
        } else {
            trackStateTryCatch();
        }
    }

    __listenEvents() {
        $(this).on('showBrowseDidRender', () => {
            // reinitialize blazy object
            if (CBS.Registry.lazyImage !== undefined) {
                setTimeout(() => {
                    CBS.Registry.lazyImage.revalidate();
                }, 100);
            }

            try {
                this.doEllipsify();
            } catch (e) {
                console.log('We caught ellipsify error exception!');
            }
        });
    }

    __initSubNavTracking() {
        $('.subnav__items li').on('click', function (e) {
            let element = $(e.currentTarget)[0];
            const col = $(element).prevAll('li').length.toString();
            const category = e.currentTarget.innerText
            let trackParams = {
                menuItemLabel: `Shows-${category}`,
                menuOrientation: 'header',
                posColNum: col,
                posRowNum: '0',
                showBrowseCategory: category
            }

            om.trackAction('trackSubMenu', trackParams);
            localStorage.setItem('trackSubMenu', JSON.stringify(trackParams));
        });
    }
    
    __initTracking() {
        checkElement('.show-browse-item').then((element) => {
            //track in-app messaging view
            CBS.Promises.Tracking.onLoad(() => {
                this.initButtonTracking(this);
            });
        });

        async function checkElement(selector) {
            const querySelector = document.querySelector(selector);
            while (querySelector === null) {
                await rafAsync();
            }
            return querySelector;
        }

        function rafAsync() {
            return new Promise((resolve) => {
                requestAnimationFrame(resolve);
            });
        }
    }

    initButtonTracking(_self) {
        
        $('.show-browse-item').on('click', function (e) {
            var scrollPosition = $(document).scrollTop();
            sessionStorage.setItem(
                'scrollPosition_movies_' + _self.category,
                scrollPosition.toString()
            );
            let section_title = $(this).parent().prev().text();
            section_title =
                section_title.indexOf('alphabetically') === -1 ? section_title : 'Popular';
            let data = $(this).find('a').attr('aa-link');
            if (data) {
                var dd = data.split('|');
            }

            let _parent = $(this).parent();
            let _grandparent = _parent.parent();
            let _grids = _grandparent.find('div.show-browse-grid');
            let rowNum;

            for (let i = 0; i < _grids.length; i++) {
                if (_parent[0] === _grids[i]) {
                    rowNum = i;
                }
                rowNum = rowNum === 0 ? '0' : rowNum; //tracking treats int 0 as boolean and doesn't capture the value
            }
            let _sibs = _parent.find('article.show-browse-item');
            let colNum = 0;
            for (let i = 0; i < _sibs.length; i++) {
                if ($(this)[0] === _sibs[i]) {
                    colNum = i;
                }
                colNum = colNum === 0 ? '0' : colNum;
            }

            let trackParams = {
                pageType: 'category_door',
                pageURL: '/shows/' + _self.category + '/',
                screenName: 'shows/' + _self.category,
                showBrowseCategory: _self.category,
                showGenre: _self.category,
                showSeriesId: typeof dd[5] !== undefined ? dd[5] : '',
                showTitle: typeof dd[4] !== undefined ? dd[4] : '',
                showSeriesTitle: typeof dd[4] !== undefined ? dd[4] : '',
                PPlusSubscriberBadge: typeof dd[14] !== undefined ? dd[14] : '',
                rowHeaderTitle: section_title,
                posRowNum: rowNum,
                posColNum: colNum,
                contentLocked: dd[23]
            };

            om.trackAction('trackShowBrowseTileSelect', trackParams);
            localStorage.setItem('trackShowBrowseTileSelect', JSON.stringify(trackParams));
        });
    }

    _setupMovies(cat) {
        if (cat === 'movies' && !this.initialIsMovies) {
            $(
                '<section id="show-browse-bottom" class="padded-container browse-more-bottom"><a href="/movies/1" id="movies_next" class="browse-more-bottom-btn button secondary load-more-button">Load More</a></section>'
            ).insertAfter('.show-browse-container');

            let boxElement = document.querySelector('#show-browse-bottom');
            let options = {
                root: null,
                rootMargin: '20px 0px 0px 0px',
                threshold: 0
            };

            let observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.start += 1;
                        this.__setNextRouteXHR(cat + '/' + this.start);
                        this.loadMoreToGrid();
                    }
                });
            }, options);
            observer.observe(boxElement);
        }
        this.setTrendingLimit();
    }

    __setupButtons() {
        this.buttons.click((e) => {
            e.preventDefault();

            let btn = $(e.target);
            this.start = 0;

            if (!btn.hasClass('active')) {
                // update subnav styles
                this.buttons.removeClass('active');
                btn.addClass('active');

                // reset the route for the ajax call & push state
                this.nextRoute = btn.attr('href');
                this.__setNextRouteXHR(btn.data('category'));
                this.doAjax();

                if (btn.data('category') === 'movies') {
                    //                    this._setupMovies(btn.data('category'));
                } else {
                    $('#show-browse-bottom').detach();
                }
            }
        });
    }

    __setNextRouteXHR(category) {
        if (category === 'popular') {
            this.nextRouteXHR = this._routePrefix;
        } else {
            this.nextRouteXHR = this._routePrefix + category + '/';
        }
    }

    __setupResizeHandler() {
        $(window).on('resize', () => {
            this.doEllipsify();
        });
    }

    doAjax(saveState) {
        let route = this.nextRouteXHR;
        saveState = typeof saveState === 'boolean' ? saveState : true;

        $.ajax({
            url: route,
            dataType: 'json'
        }).done((resp) => {
            this.resp = resp;
            this.handleSuccess(saveState);
        });
    }

    loadMoreToGrid() {
        let route = this.nextRouteXHR;

        $.ajax({
            url: route,
            dataType: 'json'
        }).done((resp) => {
            this.resp = resp;
            this._addToGrid(this.gridContainer, this.resp.result);
            $(this).trigger('showBrowseDidRender');
        });
    }

    handleSuccess(saveState) {
        // save state when clicking the subnav, not on back
        if (saveState === true) {
            this.updateState();
        }
        this.manipulateMeta();
        this.displayResults();
        if (saveState === true) {
            this.saveState();
        }
    }

    saveState() {
        // push updated category, title, nextRoute
        window.history.pushState(
            { category: this.category },
            this.metaTitle.text(),
            this.nextRoute
        );
        //update pageType
        if (this._getCategory() === 'movies') {
            this.trackView({
                pageType: 'movie',
                siteHier: 'movies',
                movieBrowseCategory: this._getCategory(),
                showGenre: null,
                pageUrl: window.location.protocol + '//' + window.location.host + this.nextRoute
            });
        } else {
            this.trackView({
                pageType: 'category_door',
                siteHier: 'category_door',
                showBrowseCategory: this._getCategory(),
                movieGenre: null,
                pageUrl: window.location.protocol + '//' + window.location.host + this.nextRoute
            });
        }
    }

    updateState() {
        this._setCategory(this.resp.result.category);
    }

    manipulateMeta() {
        if (this.resp.result.seo) {
            let seo = this.resp.result.seo;
            this.metaTitle.text(seo.meta_title);
            this.metaDesc.attr('content', seo.meta_description);
            this.metaOgTitle.attr('content', seo.social_title);
            this.metaOgDesc.attr('content', seo.social_description);
        }
    }

    displayResults() {
        // scroll user to top
        $('html, body').animate(
            {
                scrollTop: 0
            },
            300
        );

        // clear out existing results
        this.clearGrid();

        if (this._getCategory() === 'movies') {
            this._setupMovies(this.category);
        }

        this.displayAtoZ();
        this.setTrendingLimit();

        this.initButtonTracking(this);
    }

    updateSubnavState() {
        let self = this;
        this.buttons.each(function () {
            $(this).removeClass('active');
            if ($(this).data('category') === self.category) {
                $(this).addClass('active');
            }
        });
    }

    clearGrid() {
        this.container.html('');
    }

    displayAtoZ() {
        if (this.resp.result.data !== null) {
            // loop the ajax response result, each letterBlock is an object containing a result obj passed to _renderGrid
            this.resp.result.data.forEach((letterBlock) => {
                this._renderGrid(this.container, letterBlock.result);
            });
        }
        $(this).trigger('showBrowseDidRender');
    }

    displayCategory() {
        // simply render the single grid for the selected category
        this._renderGrid(this.container, this.resp.result);
        $(this).trigger('showBrowseDidRender');
    }

    _renderShowItemTemplate(obj) {
        return showBrowseItem(obj);
    }

    _renderGrid(mountView, result) {
        if (result.data === null) return false;

        let grid = '';

        // render the items to the grid container ^
        result.data.forEach((obj, idx) => {
            obj.pos = idx + 1;
            obj.category = this.category;
            grid += this._renderShowItemTemplate(obj);
        });

        let _title = result.title;
        if (CBS.Registry.brand.name !== 'PPLUS') {
            _title = result.title.length > 1 ? '' : result.title;
        }
        let layout = $(showBrowseLayout({ title: _title }));
        layout
            .filter('div.show-browse-grid.grid.portrait')
            .attr('aa-region', result.category)
            .append(grid);
        mountView.append(layout);
    }

    _addToGrid(mountView, result) {
        let grid = '';

        // render the items to the grid container
        if (result.data !== null) {
            var nextUrl = '/movies/' + this.start;
            $('#movies_next').attr('href', nextUrl);
            history.pushState({ urlPath: nextUrl }, '', nextUrl);

            result.data.forEach((obj, idx) => {
                obj.pos = idx + 1;
                obj.category = this.category;
                grid += showBrowseItem(obj);
            });
            $('.show-browse-grid').append(grid);

            if (result.data.length < this.movieLoadSize) {
                $('#movies_next').css('display', 'none');
            }
        } else {
            $('#movies_next').css('display', 'none');
        }
    }

    _getCategory() {
        return this.category;
    }

    _setCategory(category = '') {
        this.category = category;
        // Triggers Braze event
        if (CBS.Registry.Features.braze_sdk === true) {
            import('shared/braze_events/events').then(({ onBrowsePageView }) =>
                onBrowsePageView(category, this.brazeCampaignParams)
            );
        }
        return this.category;
    }

    doEllipsify() {
        this.container.ellipsify();
    }

    /**
     * Generic view tracking
     * @param {Object} params
     */
    trackView(params) {
        if (typeof om == 'undefined') {
            setTimeout(() => {
                om.trackView(params);
            }, 2000);
        } else {
            om.trackView(params);
        }
    }

    /**
     * Trending section limited to 2 rows of items in the grid, at any breakpoint
     */
    setTrendingLimit() {
        window.onresize = this.setTrendingSectionLimit;
        this.setTrendingSectionLimit();
    }

    setTrendingSectionLimit() {
        let b = new BreakPoints();
        let currentLimit = this.rowItemsByBreakpoint[b.getCurrentBreakpointName()];
        let trendingItems = $('.show-browse-grid.trending').find('.show-browse-item');
        for (let i = 0; i < trendingItems.length; i++) {
            if (i < currentLimit) {
                $(trendingItems[i]).addClass('show');
            } else {
                $(trendingItems[i]).removeClass('show');
            }
        }
    }
}
